import React, { useMemo } from 'react';

import Table from './Table';
import {
  StyledContainer,
  StyledTableContainer,
  StyledSubheader,
  StyledHeader,
} from './styled';
import { phaseToRound } from '../../service/data';
import { formatMatchWhen, useDisplayTimezone } from '../../service/localTime';

const cupWhen = (value) =>
  formatMatchWhen(value, {
    isCup: true,
    dateFormat: 'D MMM',
    timeFormat: 'HH:mm',
  }) ||
  value ||
  '';

const LeagueCalendar = ({ calendar, phase }) => {
  const zone = useDisplayTimezone();
  const data = useMemo(
    () =>
      (calendar || []).map((item) => ({
        round: item.round,
        date: cupWhen(item.date),
        status: item.status,
      })),
    [calendar, zone]
  );

  const columns = useMemo(
    () => [
      {
        Header: () => null,
        accessor: 'round',
      },
      {
        Header: () => null,
        accessor: 'date',
      },
      {
        Header: () => null,
        accessor: 'status',
      },
    ],
    []
  );
  return (
    <StyledContainer>
      <StyledSubheader>Upcoming Round</StyledSubheader>
      <StyledHeader>{phaseToRound[phase]}</StyledHeader>
      <StyledTableContainer>
        <Table data={data} columns={columns} phase={phase} />
      </StyledTableContainer>
    </StyledContainer>
  );
};

export default LeagueCalendar;
